import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import Chart from '../Chart';
import { GET_FILE_BY_ID_QUERY } from '../../constants';

const ChartFeWrapper = ({ chartFileId, ...props }) => {
  const { loading, data: { file } = {} } = useQuery(GET_FILE_BY_ID_QUERY, {
    variables: { id: chartFileId },
    skip: !chartFileId
  });
  if (loading || !chartFileId || !file) return null;

  return <Chart {...props} chartFileUrl={file.url} />;
};

ChartFeWrapper.propTypes = {
  chartFileId: PropTypes.string
};

ChartFeWrapper.defaultProps = {
  chartFileId: null
};

export default ChartFeWrapper;
